(() => {
  const initialize = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const scrollArea = root.querySelector('[data-note-tabs]');
    const scrollButtons = [...root.querySelectorAll('[data-note-scroll]')];

    if (scrollArea && scrollButtons.length) {
      const updateScrollButtons = () => {
        const maxScroll = scrollArea.scrollWidth - scrollArea.clientWidth;
        const hasOverflow = maxScroll > 2;
        scrollButtons.forEach((button) => {
          const direction = button.dataset.noteScroll;
          const isStart = scrollArea.scrollLeft <= 2;
          const isEnd = scrollArea.scrollLeft >= maxScroll - 2;
          button.hidden = !hasOverflow;
          button.disabled = !hasOverflow || (direction === 'previous' ? isStart : isEnd);
        });
      };

      scrollButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const direction = button.dataset.noteScroll === 'next' ? 1 : -1;
          scrollArea.scrollBy({ left: direction * Math.max(scrollArea.clientWidth * 0.72, 260), behavior: 'smooth' });
        });
      });

      scrollArea.addEventListener('scroll', updateScrollButtons, { passive: true });
      window.addEventListener('resize', updateScrollButtons);
      updateScrollButtons();
    }

    const filterInput = root.querySelector('[data-note-filter-input]');
    const filterStatus = root.querySelector('[data-note-filter-status]');
    const filterItems = [...root.querySelectorAll('[data-note-filter-item]')];

    if (filterInput && filterItems.length) {
      const filterNotes = () => {
        const query = filterInput.value.trim().toLocaleLowerCase();
        const shouldFilter = query.length >= 3;
        let visibleCount = 0;

        filterItems.forEach((item) => {
          const name = item.textContent.trim().toLocaleLowerCase();
          const visible = !shouldFilter || name.includes(query);
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (filterStatus) {
          if (!shouldFilter) filterStatus.textContent = '';
          else filterStatus.textContent = visibleCount
            ? `${visibleCount} note${visibleCount === 1 ? '' : 's'} found`
            : 'No matching notes';
        }

        if (scrollArea) {
          scrollArea.scrollTo({ left: 0, behavior: 'smooth' });
          scrollArea.dispatchEvent(new Event('scroll'));
        }
      };

      filterInput.addEventListener('input', filterNotes);
    }

    const tabs = [...root.querySelectorAll('[data-note-tab]')];
    const panels = [...root.querySelectorAll('[data-note-panel]')];
    if (!tabs.length) return;

    const activate = (id, focus = false) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.noteTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });

      panels.forEach((panel) => {
        const active = panel.dataset.notePanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.noteTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else next = (index - 1 + tabs.length) % tabs.length;
        activate(tabs[next].dataset.noteTab, true);
      });
    });

    activate((tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0]).dataset.noteTab);
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-shop-by-note]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const tab = event.target.querySelector('[data-note-tab]');
    if (tab) tab.click();
  });
})();
